//-- Copyright (c) 2021 TMT Insights Group, LLC
// @ts-nocheck
import React from 'react';
import { Thumbnail, TitleTypeLabel } from '@tmt-insights/oms_fe_core/columns';
import { Typography } from '@tmt-insights/oms_fe_core/material';
import { getLineageMetaTitle } from '@tmt-insights/oms_fe_core/utils';
import { AllTableColumnsConfig } from '@/__configs/config_types';
import { LineageMeta, TitleEntity } from '@/redux/slices/slice_types';

const columns: AllTableColumnsConfig<TitleEntity> = {
  thumbnail_link: {
    label: '',
    disableSort: true,
    width: 50,
    render: (cell: TitleEntity['thumbnail_link'], row: TitleEntity) => <Thumbnail src={cell} type={row.entity_type} />
  },
  hid: {
    label: 'Title ID',
    sortField: 'id',
    render: (cell: TitleEntity['hid']) => (cell ? <strong style={{ color: 'var(--primary-main)' }}>{cell}</strong> : '-')
  },
  lineage_meta__series_name: {
    label: 'Title',
    disableSort: true,
    minWidth: 280,
    render: (cell: LineageMeta['series_name'], row: TitleEntity) => {
      return (
        <>
          <Typography sx={{ fontWeight: 'bold' }}>{cell}</Typography>
          <Typography variant="caption">{getLineageMetaTitle(row)}</Typography>
        </>
      );
    }
  },
  program_type: {
    label: 'Program Type',
    disableSort: true,
    render: (cell: TitleEntity['program_type']) => <TitleTypeLabel type={cell} />
  },
  release_year: {
    label: 'Release Year',
    render: (cell: TitleEntity['release_year']) => (cell ? new Date(cell).getFullYear() : null)
  },
  program_id: {
    label: 'Program ID'
  },
  runtime: {
    label: 'Runtime',
    disableSort: true,
    render: (cell: TitleEntity['runtime']) => (cell ? `${cell}m` : null)
  }
};

export default columns;
